export const courseAccessGateText = {
  title: 'Feature Deactivated',
  subtitle: 'You don’t have access to some features',
  accessNotAllowed: 'Access not allowed to:',
  contactAdmin:
    'Please contact your Workspace administrator for further information.',
  home: 'Home',
};
